import * as utils from '../functions/utils';
import { ILocation } from '../interfaces/IGroup';
import { IGroupBanner, IGroupProfileDetail, ITempInfo } from '../types/clubProfile';
import Group from './group';

export interface IGroupDetailOwner {
  clubID: number;
  approvalState: string;
  profileDetail: IGroupProfileDetail;
  banner: IGroupBanner;
  memberSettings: {
    memberType: number;
    minAge: number;
    maxAge: number;
    googleMapPlace?: ILocation;
  };
  tempInfo: ITempInfo | undefined;
  stats: {
    posts: number;
    albums: number;
    events: number;
    photos: number;
    videos: number;
    eventsPast: number;
  };
}

export default class GroupDetailOwner {
  clubID: number;
  approvalState: string;
  profileDetail: IGroupProfileDetail;
  banner: IGroupBanner;
  memberSettings: {
    memberType: number;
    minAge: number;
    maxAge: number;
    googleMapPlace?: ILocation;
  };
  tempInfo: ITempInfo | undefined;
  stats: {
    posts: number;
    albums: number;
    events: number;
    photos: number;
    videos: number;
    eventsPast: number;
  };

  constructor() {
    this.clubID = 0;
    this.approvalState = '';
    this.profileDetail = {} as IGroupProfileDetail;
    this.banner = {} as IGroupBanner;
    this.memberSettings = {
      memberType: -1,
      minAge: 18,
      maxAge: 99,
    };
    this.tempInfo = {} as ITempInfo;
    this.stats = {
      posts: 0,
      albums: 0,
      events: 0,
      photos: 0,
      videos: 0,
      eventsPast: 0,
    };
  }

  static mappingDetailObject = (detail: any) => {
    let _detail = {} as IGroupProfileDetail;
    _detail = {
      tags: detail.Tags,
      keywords: detail.Keywords,
      clubName: detail.ClubName,
      googleMapPlace: {
        ...detail.GoogleMapPlace,
        StateName: detail.GoogleMapPlace?.StateName || detail.GoogleMapPlace?.LocationName || '',
        GoogleMapPlacesId: detail.GoogleMapPlace?.PlacesId || '',
      },
      privacyType: detail.PrivacyType,
      visibilityType: detail.VisibilityType,
      description: detail.Description,
      phone: detail.Phone,
      displayEmail: detail.DisplayEmail,
      website: detail.Website,
      rules: detail.Rules,
      enableGuestInteraction: detail.EnableGuestInteraction,
      allowAutoJoin: detail.AllowAutoJoin,
      canMembersPost: detail.CanMembersPost,
    };
    return _detail;
  };

  static mappingObjectOwner(data: any) {
    let _group = Object.assign(new GroupDetailOwner(), data);
    _group.clubID = data.ClubID;
    _group.approvalState = data.ApprovalState;
    _group.profileDetail = data.ProfileDetail ? GroupDetailOwner.mappingDetailObject(data.ProfileDetail) : ({} as IGroupProfileDetail);
    _group.banner = data.Banner ? Group.mappingBanner(data.Banner) : {};
    if (data.Stats) {
      _group.stats = {
        posts: data.Stats.Posts,
        albums: data.Stats.Albums,
        events: data.Stats.Events,
        photos: data.Stats.Photos,
        videos: data.Stats.Videos,
        eventsPast: data.Stats.EventsPast,
      };
    }
    if (data.TempInfo) {
      _group.tempInfo = {
        name: data.TempInfo.Name,
        isNameRejected: data.TempInfo.IsNameRejected,
        description: data.TempInfo.Description,
        isDescriptionRejected: data.TempInfo.IsDescriptionRejected,
        rules: data.TempInfo.Rules,
        isRulesRejected: data.TempInfo.IsRulesRejected,
      };
    }
    if (data.MemberSetting) {
      _group.memberSettings = {
        memberType: data.MemberSetting.MemberType,
        minAge: data.MemberSetting.MinAge,
        maxAge: data.MemberSetting.MaxAge,
        googleMapPlace: data.MemberSetting.GoogleMapPlace
          ? {
              StateName: data.MemberSetting.GoogleMapPlace.StateName || data.MemberSetting.GoogleMapPlace.LocationName,
              GoogleMapPlacesId: data.MemberSetting.GoogleMapPlace.PlacesId,
            }
          : null,
      };
    }
    _group = utils.cleanObjectKeys(Object.keys(new GroupDetailOwner()), _group);
    return _group;
  }
}
